import { State0 } from './State0';
import { State1 } from './State1';
import { State2 } from './State2';
import { State3 } from './State3';
import { State4 } from './State4';
import { State5 } from './State5';
import { State6 } from './State6';
import { State7 } from './State7';
import { State8 } from './State8';

export type IWebStateEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const getIconsByState = (state: number) => {
  switch (state) {
    case 0:
      return <State0 />;
    case 1:
      return <State1 />;
    case 2:
      return <State2 />;
    case 3:
      return <State3 />;
    case 4:
      return <State4 />;
    case 5:
      return <State5 />;
    case 6:
      return <State6 />;
    case 7:
      return <State7 />;
    case 8:
      return <State8 />;
  }
};
